import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Twin-post village notice board with a broad plank face.
const build: (ctx: DecoBuildCtx) => void = ({ box, seed }) => {
  const wood = shade(0x8a6a42, (rand(seed) - 0.5) * 0.12);
  const board = shade(0xc4a574, (rand(seed + 1) - 0.5) * 0.1);
  const paper = shade(0xe8e0d0, (rand(seed + 2) - 0.5) * 0.05);
  box(-0.7, 0.85, 0, 0.14, 1.7, 0.14, wood);
  box(0.7, 0.85, 0, 0.14, 1.7, 0.14, wood);
  box(0, 1.55, 0, 1.7, 0.12, 0.12, wood);
  box(0, 0.95, 0, 1.7, 0.12, 0.12, wood);
  box(0, 1.25, 0.06, 1.55, 0.95, 0.08, board);
  box(-0.35, 1.4, 0.12, 0.45, 0.35, 0.02, paper);
  box(0.3, 1.15, 0.12, 0.5, 0.4, 0.02, shade(paper, -0.06));
  box(0.05, 1.45, 0.12, 0.35, 0.28, 0.02, shade(paper, 0.04));
};

export default build;
